import React, { useState } from "react";
import { Tabs, Tab, Box,  } from "@material-ui/core";
import useStyls from "./styles";

function TabsWrapper({ children, defaultIndex = 0 }) {
  const [activeIndex, setActiveIndex] = useState(defaultIndex);
  const styles = useStyls();

  const handleTabChange = (event, newIndex) => {
    setActiveIndex(newIndex);
  };

  // Extract tabs and panels from children
  let tabsList = null;
  let panelsContainer = null;

  React.Children.forEach(children, (child) => {
    if (child.type === List) {
      tabsList = child;
    } else if (child.type === Panels) {
      panelsContainer = child;
    }
  });

  const tabLabels = [];
  if (tabsList) {
    React.Children.forEach(tabsList.props.children, (child) => {
      if (child.type === TabItem) {
        tabLabels.push(child.props.children);
      }
    });
  }

  const panels = [];
  if (panelsContainer) {
    React.Children.forEach(panelsContainer.props.children, (child, index) => {
      if (child.type === Panel) {
        panels.push({ ...child.props, index });
      }
    });
  }

  return (
    <Box className={styles.container}>
      <Tabs
        value={activeIndex}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
      >
        {tabLabels.map((label, index) => (
          <Tab key={index} label={label} className={styles.tab} />
        ))}
      </Tabs>

      <Box mt={2}>
        {panels.map((panel, index) => (
          <TabPanel key={index} index={index} activeIndex={activeIndex}>
            {panel.children}
          </TabPanel>
        ))}
      </Box>
    </Box>
  );
}

function TabPanel({ children, index, activeIndex }) {
  if (activeIndex !== index) return null;

  return <Box p={2}>{children}</Box>;
}

function List({ children }) {
  return <>{children}</>;
}

function TabItem({ children }) {
  return <>{children}</>;
}

function Panels({ children }) {
  return <>{children}</>;
}

function Panel({ children }) {
  return <>{children}</>;
}

TabsWrapper.List = List;
TabsWrapper.Tab = TabItem;
TabsWrapper.Panels = Panels;
TabsWrapper.Panel = Panel;

export default TabsWrapper;
